import FactorAttributionSelectorComplication from './FactorAttributionSelectorComplication';

export default FactorAttributionSelectorComplication
